<template>
  <tr
    class="sb-data-table__row"
    :class="{
      'sb-data-table__row--selected': isSelected && allowSelection,
    }"
  >
    <td
      v-if="allowSelection"
      class="sb-data-table__body-cell sb-data-table__col-selection"
    >
      <SbCheckbox
        :id="rowId"
        v-model="isSelected"
        hide-label
        :disabled="!isSelectable"
        :label="mainRowIdentifier ? `Select row '${mainRowIdentifier}'` : ''"
        :data-testid="`sb-data-table-body-row-checkbox-${rowId}`"
      />
    </td>

    <slot v-if="$slots.default" />

    <component
      :is="rowHeaderIndex === index ? 'th' : 'td'"
      v-for="(elem, index) in headers"
      v-else
      :key="index"
      :scope="rowHeaderIndex === index ? 'row' : undefined"
      class="sb-data-table__body-cell"
      :class="{
        'sb-data-table__col-main': rowHeaderIndex === index,
      }"
    >
      {{ row[elem.value] }}
    </component>
  </tr>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import SbCheckbox from '../../Checkbox'
import SbIcon from '../../Icon'
import sharedProps from '../sharedProps'
import type { DataTableItem } from '../types'
import { useDataTable } from '../helpers'

export default {
  name: 'SbDataTableBodyRow',

  components: {
    SbCheckbox,
    SbIcon,
  },

  props: {
    allowSelection: sharedProps.allowSelection,
    headers: sharedProps.headers,
    selectedRows: sharedProps.selectedItems,
    row: {
      type: Object as PropType<DataTableItem>,
      default: () => ({}),
    },
    rowId: {
      type: String,
      default: '',
    },
  },

  setup() {
    const { context } = useDataTable()

    return {
      context,
    }
  },

  computed: {
    rowHeaderIndex() {
      return this.headers.findIndex((col) => col.rowHeader)
    },
    isSelected: {
      get() {
        return this.selectedRows?.some(
          (row) => JSON.stringify(row) === JSON.stringify(this.row),
        )
      },
      set() {
        this.handleRowSelected()
      },
    },
    isSelectable() {
      return this.row?.selectable !== false
    },
    mainRowIdentifier() {
      return typeof this.row === 'object' &&
        this.row !== null &&
        this.context.rowFieldIdentifier in this.row
        ? this.row[this.context.rowFieldIdentifier]
        : undefined
    },
  },

  methods: {
    handleRowSelected() {
      if (!this.allowSelection) {
        return
      }

      this.isSelected
        ? this.context.deselectRow(this.row)
        : this.context.selectRow(this.row)
    },
  },
}
</script>
